export const PROFILE_PREVIEW_MODULE_ID = 'profile-preview-module';

export const LOAD_PROFILE_PREVIEW_MODULE = () =>
  import('@capital-access/profiles/preview').then(m => m.ProfilePreviewModule);
